import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearTaskReference, closeTaskPopup, setCopiedAndRedirect } from "../redux/taskSlice";

const UrlChangeTracker = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { copiedAndRedirecred } = useSelector((state) => state.task);

  useEffect(() => {
    if (!copiedAndRedirecred) {
      dispatch(clearTaskReference());
      dispatch(closeTaskPopup());
    } 
  }, [location, dispatch]);

  useEffect(() => {
    const decoded = decodeURIComponent(location.pathname);

    // Check for encoded <span in path
    if (!decoded.includes('<span') || !decoded.includes('data-text=')) return;

    // Extract the data-text value from decoded string
    const dataTextMatch = decoded.match(/data-text="(.*?)"/);
    if (!dataTextMatch || !dataTextMatch[1]) return;

    const extractedText = dataTextMatch[1]; // like "TEST DESCRIPTION"

    // Replace entire <span ...>...</span> structure with clean text
    let cleanedDecodedPath = decoded.replace(/<span.*?data-text=".*?".*?>.*?<\/span>/g, extractedText);
    cleanedDecodedPath = cleanedDecodedPath.replaceAll(/<span.*?>.*?<\/span>/g, '');

    // Finally, encode the cleaned path again
    let encodedFinal = encodeURI(cleanedDecodedPath);
    encodedFinal = encodedFinal.replace("%3C/span%3E","")
    // Navigate only if URL is actually different
    if (encodedFinal !== location.pathname) {
      navigate(encodedFinal, { replace: true });
    }
  }, [location, navigate]);

  return null;

}

export default UrlChangeTracker